import _ from 'lodash';
import { useMemo } from 'react';
import { Outlet } from 'react-router';
import { connect } from 'react-redux';
import type { RootState } from 'store';
import Header from 'app/layout/components/header/Header';
import Notification from 'app/layout/components/Notification';
import Sider from 'app/layout/components/Sider';
import { Content } from 'app/layout/components';
import { getSidebarSizes } from 'utils/styledHelpers';
import { useLayout } from 'contexts/LayoutContext';
import { selectCurrentBrandVersion } from 'selectors';
import { selectUserPartnerAccessIds } from 'app/auth/selectors';
import { useAppSelector } from 'store/hooks';
import { arrayToTree } from 'utils/utils';
import { StyledLayout } from './Layouts.styled';
import type {
  BaseLayoutProps,
} from './types';

const sidebarSizes = getSidebarSizes();
const defPartnerAccessIds: number[] = [];

const BaseLayout = ({
  routers = [],
  page = '',
  width = sidebarSizes.width,
  collapsedWidth = sidebarSizes.collapsedWidth,
  isNewVersion,
}: BaseLayoutProps) => {
  const { hideLayout } = useLayout();

  const partnerAccessIds = useAppSelector(selectUserPartnerAccessIds) ?? defPartnerAccessIds;

  const filteredRouters = useMemo(
    () => _.cloneDeep(routers).filter(
      (el) => el.menuItem
                  && !el.hide?.({ isNewVersion, partnerAccessIds }),
    ),
    [routers, isNewVersion, partnerAccessIds],
  );

  const menus = useMemo(
    () => arrayToTree(
      filteredRouters,
      'id',
      'menuParentId',
    ),
    [filteredRouters],
  );

  if (hideLayout) {
    return (
      <StyledLayout>
        <Content noPadding>
          <Outlet />
        </Content>
      </StyledLayout>
    );
  }

  return (
    <>
      <Notification />
      <Header
        collapsedWidth={collapsedWidth}
        width={width}
      />
      <StyledLayout>
        {!!filteredRouters.length && (
          <Sider
            menus={menus}
            collapsedWidth={collapsedWidth}
            width={width}
            page={page}
          />
        )}
        <Content>
          <Outlet />
        </Content>
      </StyledLayout>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  isNewVersion: selectCurrentBrandVersion(state),
});

export default connect(mapStateToProps)(BaseLayout);
